/**
 * Labstep
 *
 * @module components/ProtocolCollection/Action/Share
 * @desc Share a protocolCollection with all users on the platform
 */

import { EntityActionShare } from 'labstep-web/components/Entity/Action/Share';
import type React from 'react';
import type { IProtocolCollectionActionShareProps } from './types';

export const ProtocolCollectionActionShare: React.FC<
  IProtocolCollectionActionShareProps
> = ({ protocolCollection }) => (
  <EntityActionShare entity={protocolCollection} />
);
